import { gql } from '@apollo/client';

export const CREATE_CALMET_WITH_WRF_CONFIGURATION = gql`
    mutation createCalmetWithWrfConfiguration($input: CreateCalmetWithWrfInput!) {
        facility {
            modelConfigurations {
                calmetConfigurations {
                    createCalmetWithWrf(input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
